import styled from 'styled-components';
import { Tooltip } from '@mui/material';

const SubscriptionBox = styled.div`
    border-radius: 10px;
    border: 1px solid #e5e5e5;
    background: #fff;
    display: flex;
    max-width: 1008px;
    width: 100%;
    padding: 12px 16px;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;

    @media (max-width: ${props => props.$isPaidPlan ? '774px' : '894px'}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const TitleSubscriptionBox = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

const SubscriptionContent = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    @media (max-width: 708px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const SubscriptionTitle = styled.span`
    overflow: hidden;
    color: #0a0a0a;
    text-overflow: ellipsis;
    font-family: "Montserrat";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

const SubscriptionSubtitle = styled.span`
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    color: #0a0a0a;
    text-overflow: ellipsis;
    font-family: "Montserrat";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const StatusBadge = styled.div`
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0);
    background: ${(props) =>
        props.$pending ? "#CD8200" : props.$active ? "#007910" : "#CD0000"};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const StatusText = styled.span`
    color: #fef2f2;
    font-family: "Montserrat";
    font-size: 12px;
    font-weight: 600;
`;

export const TooltipContent = styled.div`
    color: #fff;
`;

export const PaymentLink = styled.a`
    color: #73cecc;
    text-decoration: underline;
`;

const BasicTitle = styled.div`
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #181122;
    margin-bottom: 12px;
`;

export default function CurrentSubscription({
    isPaidPlan,
    planTitle,
    activeUsersCount,
    statusBadgeProps,
    tooltipContent,
}) {
    return (
        <>
            <BasicTitle title={"Assinatura Atual"} />
            <SubscriptionBox $isPaidPlan={isPaidPlan}>
                <SubscriptionContent>
                    <TitleSubscriptionBox>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                        >
                            <g clipPath="url(#clip0_6079_1620)">
                                <path
                                    d="M5.99967 7.99992L7.33301 9.33325L9.99967 6.66658M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z"
                                    stroke="#0A0A0A"
                                    strokeWidth="1.33"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6079_1620">
                                    <rect
                                        width="16"
                                        height="16"
                                        fill="white"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <SubscriptionTitle>
                            {planTitle}
                        </SubscriptionTitle>
                    </TitleSubscriptionBox>
                    <SubscriptionSubtitle>
                        E atualmente você já tem {activeUsersCount} usuários ativos.
                    </SubscriptionSubtitle>
                </SubscriptionContent>
                <Tooltip
                    title={tooltipContent}
                    placement="top"
                    arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "#000",
                                color: "#FFF",
                                fontSize: "12px",
                                padding: "5px 12px",
                                "& .MuiTooltip-arrow": {
                                    color: "#000",
                                },
                                "& a": {
                                    color: "#73CECC",
                                },
                            },
                        },
                    }}
                >
                    <StatusBadge
                        $pending={statusBadgeProps.pending}
                        $active={statusBadgeProps.active}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <g clipPath="url(#clip0_6154_1803)">
                                <path
                                    d="M6 4V6M6 8H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
                                    stroke="#FEF2F2"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6154_1803">
                                    <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <StatusText>
                            {statusBadgeProps.statusText}
                        </StatusText>
                    </StatusBadge>
                </Tooltip>
            </SubscriptionBox>
        </>
    );
}
